<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">ATESTOS</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblAtestos"
                    :itens="atestosFiltrados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12">
                                <div class="d-flex justify-content-end">
                                    <app-ano
                                        v-model="ano"
                                        class="mr-3"
                                    ></app-ano>
                                    <b-form inline>
                                        <label class="mr-sm-2">Status</label>
                                        <b-form-select
                                            :plain="true"
                                            :options="statusAtestosSelect"
                                            v-model="statusAtestos"
                                        ></b-form-select>
                                    </b-form>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('CONT-ATESTOS-00')"
                        >
                            <b-button
                                variant="warning"
                                size="sm"
                                v-if="data.codSituacao == 0"
                                @click.stop="
                                    detalharAtesto(
                                        data.idRegistroAtestoPagamento
                                    )
                                "
                                ><i class="fa fa-check-circle-o"></i>
                                Atestar</b-button
                            >
                            <b-button
                                variant="primary"
                                size="sm"
                                v-if="data.codSituacao != 0"
                                @click.stop="
                                    detalharAtesto(
                                        data.idRegistroAtestoPagamento
                                    )
                                "
                                ><i
                                    class="fa fa-info-circle fa-lg icon-button"
                                ></i>
                                Detalhar</b-button
                            >

                            <!-- <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharAtesto(data.idRegistroAtestoPagamento)"
                            ></i> -->
                        </span>
                    </template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view @obterAtestosAtualizados="obterAtestos()"></router-view>
    </div>
</template>

<script>
import AtestosServicos from './AtestosServicos'

export default {
    components: {},

    props: {},

    data() {
        return {
            atestos: [],
            atestosFiltrados: [],
            statusAtestosSelect: [
                { text: 'TODOS', value: -1 },
                { text: 'PENDENTES', value: 0 },
                { text: 'APROVADOS', value: 1 },
                { text: 'REPROVADOS', value: 2 }
            ],
            ano: new Date().getFullYear(),
            statusAtestos: 0,
            campos: [
                {
                    key: 'dtSolicitacaoDoAtesto',
                    label: 'Data Solicitação',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'contrato.vcCodigoEstruturado',
                    label: 'Contrato',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'contrato.fornecedor.nome',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'documento',
                    label: 'Documento',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-right'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    sortable: true,
                    filterable: true,
                    type: 'status',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterAtestos() {
            this.$store.dispatch('addRequest')
            AtestosServicos.obterAtestos(this.ano).then((response) => {
                if (response) {
                    if (response.success) {
                        this.atestos = response.data
                        this.filtrarAtestos()
                    } else {
                        this.$toast.error(
                            'Erro ao obter os atestos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        filtrarAtestos() {
            if (this.statusAtestos === -1) {
                this.atestosFiltrados = this.atestos
            } else {
                this.atestosFiltrados = this.atestos.filter((item) => {
                    return item.codSituacao === this.statusAtestos
                })
            }
        },

        detalharAtesto(id) {
            this.$router.push({
                name: 'Atestos_Detalhar',
                params: {
                    atestoId: id
                }
            })
        }
    },

    created() {
        this.obterAtestos()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Atestos'
        }
    },

    watch: {
        statusAtestos() {
            this.filtrarAtestos()
        },

        ano() {
            this.obterAtestos()
        }
    }
}
</script>
